<template>
  <svg width="20" height="20" viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M256 128C256 110.3 270.3 96 288 96L420.1 96C428.6 96 436.7 99.4 442.7 105.4L502.6 165.3C508.6 171.3 512 179.4 512 187.9L512 384C512 401.7 497.7 416 480 416L288 416C270.3 416 256 401.7 256 384L256 128zM288 64C252.7 64 224 92.7 224 128L224 384C224 419.3 252.7 448 288 448L480 448C515.3 448 544 419.3 544 384L544 187.9C544 170.9 537.3 154.6 525.3 142.6L465.4 82.7C453.4 70.7 437.1 64 420.1 64L288 64zM160 192C124.7 192 96 220.7 96 256L96 512C96 547.3 124.7 576 160 576L352 576C387.3 576 416 547.3 416 512L416 496L384 496L384 512C384 529.7 369.7 544 352 544L160 544C142.3 544 128 529.7 128 512L128 256C128 238.3 142.3 224 160 224L176 224L176 192L160 192z"
      fill="currentColor"
    />
  </svg>
</template>
